import { ReactiveCore } from '@livefree/reactive';

export const reactive = new ReactiveCore('login');